import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneAppUpdateInfo from './submodules/clone';
import CreateAppUpdateInfo from './submodules/create';
import ListAppUpdateInfo from './submodules/list';
import EditAppUpdateInfo from './submodules/edit';

const AppUpdateDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getSubAppUpdates]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListAppUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addSubAppUpdateInfo]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneAppUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addSubAppUpdateInfo]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateAppUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateSubAppUpdateInfo]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditAppUpdateInfo}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default AppUpdateDashboard;
